export const PagesByContentType = new Map<string, string>([
  ['accommodation', 'acm'],
  ['activity', 'act'],
  ['airport', 'apt'],
  ['alphabet', 'abc'],
  ['bus', 'trn'],
  ['cinema', 'cin'],
  ['cross-country-skiing', 'ccs'],
  ['cross-country', 'ccs'], // todo wrong content-type
  ['event', 'evt'],
  ['four-wins', 'fwn'],
  ['gallery', 'glr'],
  ['gastronomy', 'gst'],
  ['highscore', 'hsc'],
  ['hiking', 'hkn'],
  ['important-numbers', 'imn'],
  ['information', 'ifo'],
  ['man-made-weather', 'mmw'],
  ['memory', 'mem'],
  ['mountain-railway', 'mrw'],
  ['mountain-railway-new', 'mrn'],
  ['news', 'nws'],
  ['offer', 'rst'],
  ['opening-hours', 'oph'],
  ['opening-state', 'ost'],
  ['person', 'prs'],
  ['restaurant', 'rst'],
  ['share', 'shr'],
  ['social-media', 'smd'],
  ['social-media-feed', 'smf'],
  ['street-conditions', 'stc'],
  ['temperature', 'tmp'],
  ['train', 'trn'],
  ['weather', 'wth'],
  ['webcam', 'wcm'],
  ['website', 'InAppBrowser'],
  ['videochat', 'vct'],
  ['partner', 'pnr']
]);




